// Nuevo módulo Angular para definir los servicios de la aplicación.
// Se importa en app.module.ts
import { NgModule } from '@angular/core';
import { TurnosService } from './employees/turnos.service';
import { VacacionesService } from './employees/vacaciones.service';
import { ContactosService } from './employees/contactos.service';
import { ProvinceService } from './data/province.service';
import { MunicipalityService } from './data/municipality.service';
import { PagosEnFicherosService } from './expenses/pagosEnFicheros.service';
import { A3Service } from './a3/a3.service';
import { RegistroHorasService } from './employees/registro-horas.service';
import { PeriodService } from './period/period.service';
import { CountriesService } from './data/countries.service';
import { AdminUserCommentsService } from './admin/adminUserComments.service';

// NgModule
@NgModule({
  declarations: [],
  imports: [],
  providers: [
    // Aquí se declaran los servicios
    ContactosService,
    TurnosService,
    VacacionesService,
    ProvinceService,
    PagosEnFicherosService,
    MunicipalityService,
    A3Service,
    RegistroHorasService,
    PeriodService,
    CountriesService,
    AdminUserCommentsService,
  ]
})
export class ServicesModule { }
